import { FlagCategory } from '@enums/service-request-flags.enum';
import { BaseDropdownInterface } from '@interfaces/base-dropdown.interface';

/**
 * Category options of a service request flag. The category name is the option id, because the old numeric ids had a duplicate.
 */
export const SERVICE_REQUEST_FLAG_CATEGORY_OPTIONS: Readonly<BaseDropdownInterface[]> = Object.values(FlagCategory).map((category) => ({
  id: category,
  name: category,
}));

/**
 * Maximum number of flags (active and resolved) on one service request.
 */
export const SERVICE_REQUEST_FLAGS_MAX_COUNT = 10;

/**
 * Maximum length of the reason of a new flag. An edit does not apply it, so an old flag with a longer reason stays valid.
 */
export const SERVICE_REQUEST_FLAG_REASON_MAX_LENGTH = 500;
